import './App.css';
import UnderConstruction from './UnderContruction';
import NeonBox from './components/NeonBox'
import zIndex from '@mui/material/styles/zIndex';
import Login from './pages/Login';
import Registration from './pages/Registration';
import NewPublicationDialog from './pages/NewPublicationDialog';
import { alignProperty } from '@mui/material/styles/cssUtils';
import Home from 'pages/Home';
import { ThemeProvider } from "@mui/material/styles";
import theme, { op } from './theme';
import { CssBaseline, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Stack, Typography, IconButton, Avatar } from '@mui/material';
import { AccountCircle, AddCircle } from '@mui/icons-material';
import { ApiProvider } from 'lib/ApiContext';
import ApiManager from 'lib/ApiManager'; // Importa tu clase Api
import React, { useState, useEffect, useRef } from 'react';
import { Navigate, Outlet } from "react-router";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { Menu, MenuItem, Divider, ListItemIcon, ListItemText } from '@mui/material';
import { Logout, ManageAccounts } from '@mui/icons-material';


// Components
const NavigationBar = () => (
  <nav className="navbar">
    <div className="logo">OverPower.TV</div>
    <ul className="nav-links">
      <li><a href="#">Home</a></li>
      <li><a href="#">Creators</a></li>
      <li><a href="#">Trending</a></li>
      <li><a href="#">Ads</a></li>
    </ul>
  </nav>
);

const FeaturedContent = () => (
  <section className="featured-content">
    <h2>Featured Creators</h2>
    <div className="content-cards">
      <div className="card">Creator 1</div>
      <div className="card">Creator 2</div>
      <div className="card">Creator 3</div>
    </div>
  </section>
);

const TrendingContent = () => (
  <section className="trending-content">
    <h2>Trending Now</h2>
    <div className="content-cards">
      <div className="card">Article 1</div>
      <div className="card">Article 2</div>
      <div className="card">Article 3</div>
    </div>
  </section>
);

const Footer = () => (
  <footer className="footer">
    <p>© 2025 OverPower.TV. All rights reserved.</p>
    <ul className="footer-links">
      <li><a href="#">Privacy Policy</a></li>
      <li><a href="#">Terms of Service</a></li>
      <li><a href="#">Contact Us</a></li>
    </ul>
  </footer>
);

const styles = {
  background: {
    // v2: fondo plano — el vacío es el patrón (docs/IDENTIDAD_VISUAL.md §6)
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  logo: {
    width: "250px", // Adjust the size of the logo as needed
    height: "auto",
    position: "fixed",
    alignItems: "center", 
    left: "10px",
    top: "20px",
    zIndex: 1000
  },
};

export function CyberpunkErrorDialog({ open, onClose, errorMessage }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      slotProps={{
        paper: {
          sx: {
            backgroundColor: op.bg.elevated,
            border: `1px solid ${op.border}`,
            boxShadow: '0 4px 16px rgba(0,0,0,.45)',
            borderRadius: '10px',
          },
        },
      }}
    >
      <DialogTitle sx={{ color: 'error.main' }}>
        Algo salió mal
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ color: 'text.primary', mt: 1, mb: 1 }}>
          {errorMessage}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const App = () => {
  const avatarRef = useRef(null);
  const [avatarSignedURL, setAvatarSignedURL]= useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [session, setSession] = useState(null); 
  const [userData, setUserData] = useState(null);
  const [user, setUser] = useState(null);
  const [api, setApi] = useState(null);
  const [needRegister, setNeedRegister] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [errorToShow, setErrorToShow] = useState({message: "", showError: false});
  const [openPublish, setOpenPublish] = useState(false);
  const [openComment, setOpenComment] = useState(false);
  const [selectedPublish, setSelectedPublish] = useState(null);
  const [avatarDirty, setAvatarDirty] = useState(false);
  const feedList = useRef(null);
  const navigate = useNavigate();
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const isUserMenuOpen = Boolean(userMenuAnchor);
  const openUserMenu = (e) => setUserMenuAnchor(e.currentTarget);
  const closeUserMenu = () => setUserMenuAnchor(null);
    
  
  useEffect(() => {
      setAvatarDirty(false);
      api?.GetUserData().then((value) => {
        setUserData(value);
        if (avatarRef.current)
        {
          avatarRef.current.src = value?.SignedUrl || "/images/avatar-default.webp";
        }
        setAvatarSignedURL(value?.SignedUrl);
    })
     console.log("cambiar Avatar");
  }, [avatarDirty]);

  // ...dentro del componente App:
  useEffect(() => {
    const userPool = new CognitoUserPool({
      UserPoolId: 'us-east-2_gCcm4sPzU',
      ClientId: '1k58piktqup5k1j852hau1nfqf',
    });

    const currentUser = userPool.getCurrentUser();
    if (!currentUser) return;

    currentUser.getSession((err, sessionObj) => {
      if (err || !sessionObj?.isValid()) return;
      // Reusa tu función existente para setear todo
      updateLoggedState(currentUser, sessionObj);
    });
  }, []);

  const updateLoggedState = (user, se) => {
    setLoggedIn(true);
    setUser(user);
    setSession(se);
    handleClose();

    const apiLocal = new ApiManager(user, se, logOut, onError);
    apiLocal.GetUserData().then((value) => {
      setUserData(value);
      setAvatarSignedURL(value?.SignedUrl);
    })
    setApi(apiLocal);

  }

  const onError = (message) => {
    setErrorToShow({ message: message, showError: true });
  }
  
  const hideError = () => {
    setErrorToShow({ message: "", showError: false });
  }
  
    // navegar a editar perfil (o ver perfil)
  const goToEditProfile = () => {
    closeUserMenu();
    navigate(`users/${session?.idToken?.payload?.nickname}`); // o "settings/profile"
  };

  // logout real + UI
  const logOut = () => {
    navigate ('/');
    try {
      const { CognitoUserPool } = require('amazon-cognito-identity-js');
      const userPool = new CognitoUserPool({
        UserPoolId: 'us-east-2_gCcm4sPzU',
        ClientId: '1k58piktqup5k1j852hau1nfqf',
      });
      userPool.getCurrentUser()?.signOut(); // cierra sesión en Cognito (borra persistencia)
    } catch {}
    setLoggedIn(false);
    setNeedRegister(false);
    setSession(null);
    setUser(null);
    setUserData(null);
    setApi(null);
    closeUserMenu();
  };


  const onLoginClick = () => {
    setShowLogin(true);
  }
  const handleClose = () => {
    setShowLogin(false);
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={styles.background}>

      <NeonBox width="90%">
      <Link to="/" style={{ textDecoration: "none" }}>
  <Typography 
    sx={{
      textAlign: "left", 
      margin: { 
        xs: "8px",
        sm: "10px",
        md: "10px"
      }, 
      fontSize: {
        xs: 20,
        sm: 28,
        md: 40,
        lg: 50
      }, 
      fontFamily: "Orbitron", // única aparición de Orbitron: el wordmark (IDENTIDAD_VISUAL.md §3)
      color: '#EDE9F7',
      textDecoration: "none",
      letterSpacing: { xs: 1, sm: 2, md: 3 },
      fontWeight: 900
    }}
  >
    OVERPOWER.TV
  </Typography>
</Link>

<Box
  sx={{
    position: 'absolute',
    top: { xs: 12, sm: 14, md: 16 },
    right: { xs: 12, sm: 14, md: 16 },
    zIndex: 1000
  }}
> 
  {loggedIn ? (
    <Stack direction="row" spacing={{ xs: 0.5, sm: 1, md: 1 }}>
      
      {userData?.Creator >= 0 && (
        <IconButton 
          size="large" 
          onClick={() => setOpenPublish(true)}
          sx={{
            padding: { xs: '6px', sm: '8px', md: '12px' }
          }}
        >
          <Avatar
            sx={{
              bgcolor: "primary.dark",
              width: { xs: 36, sm: 40, md: 44 },
              height: { xs: 36, sm: 40, md: 44 },
            }}
          >
            <AddCircle sx={{ fontSize: { xs: 20, sm: 22, md: 24 } }} />
          </Avatar>
        </IconButton> 
      )}
      
      <IconButton
        size="large"
        onClick={openUserMenu}
        aria-controls={isUserMenuOpen ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isUserMenuOpen ? 'true' : undefined}
        sx={{
          padding: { xs: '6px', sm: '8px', md: '12px' }
        }}
      >
        <Avatar 
          ref={avatarRef} 
          sx={{
            bgcolor: "primary.dark",
            width: { xs: 36, sm: 40, md: 44 },
            height: { xs: 36, sm: 40, md: 44 },
            fontSize: { xs: 16, sm: 18, md: 20 }
          }}
          src={userData?.SignedUrl || "/images/avatar-default.webp"}
        >
          {session?.idToken?.payload?.nickname?.charAt(0).toUpperCase() || "?"}
        </Avatar>
      </IconButton>

      <Menu
        id="user-menu"
        anchorEl={userMenuAnchor}
        open={isUserMenuOpen}
        onClose={closeUserMenu}
        onClick={closeUserMenu}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: { xs: 180, sm: 200, md: 220 },
            bgcolor: op.bg.elevated,
            color: 'text.primary',
            border: `1px solid ${op.border}`,
            boxShadow: '0 4px 16px rgba(0,0,0,.45)',
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={goToEditProfile}>
          <ListItemIcon>
            <ManageAccounts 
              fontSize="small" 
              sx={{ fontSize: { xs: 18, sm: 20 } }} 
            />
          </ListItemIcon>
          <ListItemText 
            primary="Editar perfil"
            primaryTypographyProps={{
              fontSize: { xs: 14, sm: 15, md: 16 }
            }}
          />
        </MenuItem>

        <Divider />

        <MenuItem onClick={logOut}>
          <ListItemIcon>
            <Logout 
              fontSize="small"
              sx={{ fontSize: { xs: 18, sm: 20 } }}
            />
          </ListItemIcon>
          <ListItemText 
            primary="Cerrar sesión"
            primaryTypographyProps={{
              fontSize: { xs: 14, sm: 15, md: 16 }
            }}
          />
        </MenuItem>
      </Menu>
    </Stack>
  ) : (
    <IconButton 
      onClick={onLoginClick} 
      size="large"
      sx={{
        padding: { xs: '6px', sm: '8px', md: '12px' }
      }}
    >
      <Avatar
        sx={{
          bgcolor: "primary.dark",
          width: { xs: 36, sm: 40, md: 44 },
          height: { xs: 36, sm: 40, md: 44 },
        }}
      >
        <AccountCircle sx={{ fontSize: { xs: 20, sm: 22, md: 24 } }} />
      </Avatar>
    </IconButton>
  )}
</Box>
        <ApiProvider user={user} session={session} onLogoutCallback={logOut} onErrorCallback={onError}> 
          <Outlet context={{loggedIn, openPublish, setOpenPublish, errorToShow, avatarDirty, setAvatarDirty, setShowLogin, avatarSignedURL} }/>
          <NewPublicationDialog open={openPublish} onClose={() => setOpenPublish(false)} />
        </ApiProvider>
        {/* TODO: Dialogo para hacer comentarios */}
        
        {/* Diálogo que muestra el componente Login */}
      <Dialog open={showLogin} onClose={handleClose} scroll="body"
        fullWidth={false}
        maxWidth={false}
       hideBackdrop={false}
        PaperComponent="div" // removes MUI paper styling
        slotProps={{
          paper: {
            sx: {
              m: 0,
              p: 0,
              borderRadius: 0,
              boxShadow: 'none',
              background: 'transparent',
              display: 'inline-block',
              overflow: 'visible',
            },
          },
        }}>
            <Box  sx={{
          backgroundSize: 'cover',  // or 'contain' depending on what you need
          backgroundPosition: 'center',
          height: '100vh', // Adjust the height as needed
          // Add other styling as needed
        }}>
        
          { needRegister?
          <Registration onLogin={updateLoggedState} onLogout={logOut}/> 
          :
          <Login onLogin={updateLoggedState} onNeedRegister={() => setNeedRegister(true) } />
          }
        </Box>
      </Dialog>

     <CyberpunkErrorDialog open={errorToShow.showError} onClose={hideError} errorMessage={errorToShow.message} />
      
      </NeonBox>
      </div>
    </ThemeProvider>
  );
};

export default App;